// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rs-picker-daterange-primitive.flat .rs-picker-toggle,
.rs-picker-daterange-primitive.flat .rs-picker-toggle-textbox {
  border: none;
  border-radius: 0px;
}
.rs-picker-daterange-primitive.flat .rs-picker-toggle-active {
  box-shadow: unset;
}
.rs-picker-daterange-primitive.no-caret .rs-picker-toggle-caret {
  display: none;
}
.rs-picker-daterange-primitive.transparent .rs-picker-toggle,
.rs-picker-daterange-primitive.transparent .rs-picker-toggle-textbox {
  color: inherit;
  background-color: transparent !important;
}
.rs-picker-daterange-primitive.transparent .rs-picker-toggle-value,
.rs-picker-daterange-primitive.transparent .rs-picker-toggle-clean,
.rs-picker-daterange-primitive.transparent .rs-picker-toggle-caret {
  color: inherit;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
